module.exports = __webpack_public_path__ + "img/H2.23f2fe9d.png";